import { Logout } from "@mui/icons-material";
import React from "react";
import styled from "styled-components";
import { Box, Button, Modal, Paper, Stack } from "@mui/material";
import { useAuth } from "src/components/providers/auth-context";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";
import { useTeams } from "../teams-provider";
import { useTeam } from "./team-provider";
import useTeamAction from "../hooks/use-team-action";

const TeamDeletion = styled(Button)`
    font-size: 12px;
    font-weight: 300;
    text-transform: none;
    padding: 0;
    color: ${({ theme }) => theme.palette.text.secondary};

    &:hover {
        background-color: ${({ theme }) => theme.palette.background.default};
    }
`;

const ModalContainer = styled(Paper)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
const Title = styled.h1`
    font-size: 18px;
    font-weight: 500;
    padding: 0;
    margin: 0;
`;

const TeamLeave = ({ team }) => {
    const [open, setOpen] = React.useState(false);
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const teamsApi = useTeams();
    const teamApi = useTeam();
    const { user } = useAuth();

    if (
        !team ||
        !team.members ||
        !team.members.find((member) => member.id === user.id) ||
        team.owner.id === user.id
    )
        return null;

    const leaveAction = useTeamAction(
        async () => {
            await request(`/api/teams/${team.id}/leave`, { method: "DELETE" });
            setMessage(`You were successfully removed from ${team.name}`);
            setSeverity("success");
            setIsToastTriggered(true);
            teamApi.refetch();
            teamsApi.refetch();
        },
        () => {
            setMessage(`You can not perform this action on demo mode`);
            setSeverity("warning");
            setIsToastTriggered(true);
        }
    );

    const handleSubmit = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsToastTriggered(false);
        try {
            leaveAction();
        } catch (error) {
            setMessage(`There was an error removing you from ${team.name}`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    return (
        <>
            <TeamDeletion
                startIcon={<Logout />}
                style={{ marginLeft: "5px" }}
                onClick={() => setOpen(true)}
            >
                Leave Team
            </TeamDeletion>
            <Modal
                open={open}
                onClose={() => {
                    setIsToastTriggered(false);
                    setOpen(false);
                }}
                aria-labelledby="team-leave-modal-title"
                aria-describedby="team-leave-modal-description"
            >
                <ModalContainer>
                    <Box p={3}>
                        <form onSubmit={handleSubmit}>
                            <Stack spacing={2} alignItems="flex-start">
                                <Title>Are you sure you want to leave team {team.name}</Title>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    style={{ width: "100%" }}
                                >
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            setIsToastTriggered(false);
                                            setOpen(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button type="submit" color="error">
                                        Leave
                                    </Button>
                                </Stack>
                            </Stack>
                        </form>
                    </Box>
                </ModalContainer>
            </Modal>
        </>
    );
};

export default TeamLeave;
